/**
 * Market Selector constants
 * Configuration for the unified market selector component
 */
import { SUPPORTED_CEX } from "@cede/types";

/**
 * List of supported CEX exchanges for spot trading
 * Includes SUPPORTED_CEX + Hyperliquid
 */
export const SPOT_TRADING_EXCHANGES = [...Object.values(SUPPORTED_CEX), "hyperliquid"] as const;

/**
 * Column configuration for different market types
 */
export const COLUMN_CONFIGS = {
  SPOT: {
    desktop: "grid-cols-[40px_1fr_140px]",
    mobile: "grid-cols-[40px_1fr_auto]",
    columns: ["Icon", "Symbol", "Last Price"] as const,
  },
  SPOT_WITH_BALANCE: {
    desktop: "grid-cols-[40px_1fr_130px_140px]",
    mobile: "grid-cols-[40px_1fr_auto]",
    columns: ["Icon", "Symbol", "Balance", "Last Price"] as const,
  },
  PERPS: {
    desktop: "grid-cols-[40px_1fr_140px_100px_120px]",
    mobile: "grid-cols-[40px_1fr_auto]",
    columns: ["Icon", "Symbol", "Last Price", "24h Change", "24h Volume"] as const,
  },
  PERPS_WITH_BALANCE: {
    desktop: "grid-cols-[40px_1fr_130px_140px_100px_120px]",
    mobile: "grid-cols-[40px_1fr_auto]",
    columns: ["Icon", "Symbol", "Balance", "Last Price", "24h Change", "24h Volume"] as const,
  },
} as const;

/**
 * Number of skeleton items to show while loading
 */
export const SKELETON_ITEMS_COUNT = 8;

/**
 * Price formatting options
 */
export const PRICE_FORMAT_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
} as const;
